export default function getIniUrl() {
  const host = window.location.host;
  let iniv = host.includes('edgesuite') || host.includes('parlament2021');
  if (process.env.NODE_ENV === 'development') {
    return '/json/inii.json';
  }
  return iniv ? '/json/iniv.json' : '/json/inii.json';
}
